import {
  CancelCartPayload,
  GetEventsApiPayload,
  GetInventoryApiPayload,
  GetInventoryPreviewApiPayload,
  GetInventoryPreviewApiResponse,
  GetPackagesApiPayload,
  ManageCartPayload,
} from "@/types/api.types";
import { endpoints } from "../api/endpoints";
import { useHyperFetch } from "./useHyperFetch";
import { CartManagerState } from "../store/data/purchaseSeats/cartManager";
import { EventPackage, EventType, InventoryType } from "../store/data/types";

export function useApiRoutes() {
  const getEventsApi = useHyperFetch<GetEventsApiPayload, EventType[]>(endpoints.getUpcomingEvents); // prettier-ignore
  const getPackagesApi = useHyperFetch<GetPackagesApiPayload, EventPackage[]>(endpoints.getPackages); // prettier-ignore
  const getInventoryApi = useHyperFetch<GetInventoryApiPayload, InventoryType[]>(endpoints.getInventory); // prettier-ignore
  const addRecipientApi = useHyperFetch(endpoints.addRecipient);
  const getTicketTransferDetailsApi = useHyperFetch(endpoints.getTicketTransferDetails); // prettier-ignore
  const updateRecipientSeatCountApi = useHyperFetch(endpoints.updateRecipientSeatCount); // prettier-ignore
  const updateRecipientStatusApi = useHyperFetch(endpoints.updateRecipientStatus); // prettier-ignore
  const getDetailsByTransferCodeApi = useHyperFetch(endpoints.getDetailsByTransferCode); // prettier-ignore
  const transferTicketsApi = useHyperFetch(endpoints.transferTickets);
  const manageCartApi = useHyperFetch<ManageCartPayload, CartManagerState>(endpoints.manageCart); // prettier-ignore
  const manageCartSimilarSeatsApi = useHyperFetch(endpoints.manageCartForSimilarSeats); // prettier-ignore
  const managePerkApi = useHyperFetch(endpoints.managePerks); // prettier-ignore
  const autoSeatSelectionApi = useHyperFetch(endpoints.autoSeatSelection);
  const cancelCartApi = useHyperFetch<CancelCartPayload>(endpoints.cancelCart); // prettier-ignore
  const getInventoryPreviewApi = useHyperFetch<GetInventoryPreviewApiPayload, GetInventoryPreviewApiResponse>(endpoints.getPreviewInventory); // prettier-ignore

  return {
    getEventsApi,
    getPackagesApi,
    getInventoryApi,
    addRecipientApi,
    getTicketTransferDetailsApi,
    updateRecipientSeatCountApi,
    updateRecipientStatusApi,
    getDetailsByTransferCodeApi,
    transferTicketsApi,
    manageCartApi,
    manageCartSimilarSeatsApi,
    managePerkApi,
    cancelCartApi,
    autoSeatSelectionApi,
    getInventoryPreviewApi,
  };
}
